<template>
    <v-app id="app">
        <v-app-bar app clipped-right color="bal-gray" light flat>
            <v-app-bar-nav-icon large @click.stop="toggleDrawer" />
            <v-toolbar-title>{{ `${$route.meta.title}` | t }}</v-toolbar-title>
        </v-app-bar>

        <main-drawer :drawer-open="mainDrawerOpen" />

        <v-main>
            <router-view />
        </v-main>

        <page-footer />

        <v-snackbar color="success" bottom :timeout="2500" :value="requestSuccess">
            <div style="display: flex; flex-direction: row">
                <v-icon color="#FFF">check</v-icon>
                <div class="title pa-2">{{ "Success" | t }}</div>
            </div>
        </v-snackbar>

        <v-snackbar color="error" bottom :timeout="5000" :value="requestError">
            <div class="title pa-2">{{ errorMessage }}</div>
        </v-snackbar>
    </v-app>
</template>

<script>
// Page frame of the mix recipes view (BALTT-529): app bar, main menu and request snackbars.
// No props, no events.
import MainDrawer from "../components/main-drawer.vue";
import PageFooter from "../components/page-footer.vue";
import { mapMutations, mapState } from "vuex";

export default {
    components: { MainDrawer, PageFooter },
    data() {
        return {
            mainDrawerOpen: null,
        };
    },
    computed: {
        ...mapState("RecipeStore", ["requestSuccess", "requestError", "errorMessage"]),
    },
    mounted() {
        let drawerState = null;
        try {
            drawerState = localStorage.getItem("mainDrawerOpen");
        } catch (e) {
            drawerState = null;
        }
        this.mainDrawerOpen = drawerState ? JSON.parse(drawerState) : true;
    },
    destroyed() {
        this.resetRequestState();
    },
    methods: {
        ...mapMutations("RecipeStore", ["resetRequestState"]),
        toggleDrawer() {
            this.mainDrawerOpen = !this.mainDrawerOpen;
            try {
                localStorage.setItem("mainDrawerOpen", this.mainDrawerOpen);
            } catch (e) {
                // Storage can be blocked; the menu still works for this page view.
            }
        },
    },
};
</script>
